export const WBP_TAB_TITLES = {
  tabName: "Watchlist, Ban, Pnl",
  pnlTable: "Watchlist, Ban, Pnl - PNL counter",
  masterBanTable: "Watchlist, Ban, Pnl - Master ban list",
  notesSearchTable: "Watchlist, Ban, Pnl - Watchlist notes",
} as const;
